import React from 'react';
import { VisibilityOutlined } from '@tmap/mmm-style-guide/src/Icon';
import { Alert } from '@tmap/mmm-style-guide/src/Alert';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import ColorBlocks from '../../layouts/colorBlocks';

const ModeratorAlert = styled(Alert)(({ theme }) => ({
  width: '100%',
  background: theme.palette.aqua.veryLight,
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  '&>.MuiAlert-message': {
    display: 'flex',
    width: '100%',
    padding: 0,
    alignItems: 'center',
  },
  '& .MuiButton-root': {
    textDecoration: 'underline',
  },
}));

const TextWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(0),
  },
}));

function ModeratorBanner(props) {
  const { community } = props;
  const editLink = `/moving-living/${community.slug.current}/editor`;
  const memberLink = `/moving-living/${community.slug.current}/members`;
  return (
    <ModeratorAlert icon={false}>
      <ColorBlocks.Block spacing='none'>
        <Grid container alignItems='center' justifyContent='center' sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
          <Grid item>
            <TextWrapper>
              <VisibilityOutlined sx={{ display: 'inline', marginRight: 1, fontSize: '19px' }} />
              <Typography component='span' variant='body2'>
                Community Moderator
              </Typography>
            </TextWrapper>
          </Grid>
          <Grid item xs={12} sm='auto'>
            <Button variant='text' size='small' color='secondary' href={editLink}>
              Custom Page Editor
            </Button>
          </Grid>
          <Grid item xs={12} sm sx={{ textAlign: 'right' }}>
            <Button variant='text' size='small' color='secondary' href={memberLink}>
              Manage Members
            </Button>
          </Grid>
        </Grid>
      </ColorBlocks.Block>
    </ModeratorAlert>
  );
}

export default ModeratorBanner;
